import { render, staticRenderFns } from "./ProgressBarModal.vue?vue&type=template&id=0fda2663&"
import script from "./ProgressBarModal.vue?vue&type=script&lang=js&"
export * from "./ProgressBarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports